export default {"src":"/_next/static/media/dashboard-color.58c24b57.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};